import { User } from 'redux/schemas/models/my-account';
import {
  Review,
  Exercise,
  Submitting,
  ExerciseOwner,
  PrivacySetting,
  Submission as ExerciseSubmission,
} from 'redux/schemas/models/exercise';
import { Team } from './team';

export type Submission = {
  id: number,
  body: string,
  canReview: boolean
  commented: boolean
  courseName: string | null
  coverPhotoUrl: string | null
  createdAt: string,
  followed: boolean,
  hasViewed: boolean,
  isVotable: boolean,
  lastSavedAt: string,
  liked: boolean,
  numPostsAndComments: number,
  posted: boolean,
  ownerType: ExerciseOwner,
  postsCount: number,
  title: string,
  type: 'report', // | 'Another' ?
  url: string,
  votesCount: number,
  privacySetting: PrivacySetting,
  submitting: Submitting,
  ownerId: number,
  exercise: Exercise,
  exerciseId: number,
  owner: User | Team,
  gavePublicFeedback: boolean | null,
  isPublicFeedbackOn: boolean | null,
  isRatedByCurrentUser: boolean | null,
  reviews: Review[] | null,
  mentionableUserIds?: number[];
  aiFeedback?: AISubmissionFeedback
  feedbackDataRequest?: AIFeedbackDataRequest
  // peerEvaluation: null
};

export type SubmissionsDictionary = {
  [key: number]: Submission | ExerciseSubmission,
};

export type CommentEvent = {
  commentsCount: number;
  exerciseId?: number;
  lectureComponentId: number;
  lecturePageId: number;
  numLikes?: number;
  postId: number;
  postsCount: number;
  reportId: number;
};

export type ReplyEvent = {
  commentId: number;
  commentsCount: number;
  exerciseId?: number;
  lectureComponentId: number;
  lecturePageId: number;
  numLikes?: number;
  numPostsAndComments: number;
  postId: number;
  reportId: number;
};

export type SectionContent = string | string[];

export type AISubmissionFeedback = {
  id: number;
  ownerId: number;
  ownerType: string;
  evaluation?: AIEvaluationStatus;
  feedback?: string
  workingWell?: SectionContent;
  needsImprovement?: SectionContent;
  processing: boolean;
  processedAt: string;
  status: 'error';
  reason?: string;
  errorMessage: string;
};

export enum AIEvaluationStatus {
  MEETS_EXPECTATIONS = 'meets_expectations',
  NEEDS_IMPROVEMENT = 'needs_improvement',
  EXCEEDS_EXPECTATIONS = 'exceeds_expectations',
}

export enum AIFeedbackErrorStatus {
  CONTENT_IS_TOO_SHORT = 'content_is_too_short',
  SUBMISSION_TOO_SHORT = 'submission_is_too_short',
  SUBMISSION_WITH_INVALID_TYPE = 'submission_with_invalid_type',
}

export type AIFeedbackDataRequest = {
  id: number,
  completed: boolean,
  feedbackProcessingStatus: {
    hasExternalLink: boolean,
    status?: string,
    fullErrorMessage?: string,
    errorMessage?: AIFeedbackErrorStatus,
    responseCode?: number
    submissionSkippedFiles?: string[],
  }
};
